import React from 'react'
import { Link } from 'react-router-dom'

function TeamCardItem(props) {
  return (
    <>
        <li className="team_cards__item">
            <a href={props.href} className="team_cards__item__link">
                <figure className="team_cards__item__pic-wrap">
                    <img src={props.src} className="team_cards__item__img" />
                </figure>
                <div className="team_cards__item__info">
                    <h5 className="team_cards__item__title">
                        {props.title}
                    </h5>
                    <p className="team_cards__item__description">{props.description}</p>
                </div>
            </a>
        </li>
    </>
  )
}

export default TeamCardItem
